/**
 * Data fetching procedure used anywhere.
 * moslty used with SWR hooks.
 *
 * it the fetch fails due to token expiration (unauthorized error [401]),
 * this tries to refresh the token, then retry the fetch.
 */

import { qs } from '.';
import URL from '../configs/URL';
import { mapAPIKey, PUBLIC_URL } from '../configs/config';

export interface IOPT extends RequestInit {
  params?: Record<string, string>;
}

function fetchWithRetry(
  url: RequestInfo | URL = '',
  opt: IOPT = {},
  retries = 3
): Promise<Response> {
  const { params, ...options } = opt;
  const q = opt.params ? '?' + qs(opt.params) : '';

  return fetch(`${url}${q}`, options).then(async function (response) {
    if (response.status === 401) {
      //refresh token
      await fetch(`${URL.refreshTokenUser}`, {
        method: 'POST',
        headers: {
          'x-api-key': `${mapAPIKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id: 1,
          refresh_token: localStorage.getItem('refreshToken'),
        }),
      })
        .then(async function (response) {
          if (response.ok) {
            const resp = await response.json();
            localStorage.setItem('sessionToken', resp.access_token);
            localStorage.setItem('refreshToken', resp.refresh_token);
            // update current fetch's token
            if (opt.headers && 'token' in opt.headers)
              opt.headers.token = resp.access_token;
          } else {
            window.location.assign(
              `${PUBLIC_URL}/login?redirect_to=${
                window.location.pathname + window.location.search
              }`
            );
          }
        })
        .catch(() => {
          window.location.assign(
            `${PUBLIC_URL}/login?redirect_to=${
              window.location.pathname + window.location.search
            }`
          );
        });

      return fetchWithRetry(url, opt, retries - 1);
    }

    if (!response.ok || (response.status >= 400 && response.status !== 401))
      throw response;

    return response;
  });
}

/// TODO: Fix types and arguments
const fetchTogether = (
  requests: {
    id: string | number;
    url: string;
    headers?: Record<string, string>;
  }[],
  opt: IOPT
) =>
  Promise.allSettled(
    requests.map(({ id, url, headers = {} }) =>
      fetchWithRetry(url, {
        ...opt,
        headers: { ...opt.headers, ...headers },
      }).then(async (res: Response | undefined) => {
        let response;
        try {
          response = await res?.json();
        } catch (err) {
          response = {};
        }
        return {
          [id.toString()]: response,
        };
      })
    )
  ).then((values) => {
    const result = {};
    values
      .map((v) => (v.status === 'fulfilled' ? v.value : undefined))
      .forEach((v) => {
        Object.assign(result, v);
      });

    return result;
  });

export default fetchWithRetry;
export { fetchTogether };
